/*!
 * NUIT click-capture micro-beacon (~1.5KB). First-party replacement for uniclick.js.
 * Source spec: tmp/jtbd/21-redtrack-replacement-battleplan.md  §3.1 + §3.2
 *
 * What it does:
 *   1. Reads platform click-ids (fbclid/gclid/gbraid/wbraid/ttclid/rtkcid) + utm_* + cmpid/ad_id/adset_id
 *      from location.search; reads _fbp/_ttp cookies.
 *   2. Writes a compact first-party cookie __nuit_clk (90d, .nuit.ro, SameSite=Lax) with LAST-PAID logic.
 *   3. Optionally POSTs to an explicitly configured compatible click collector.
 *   4. Writes the click record into Shopify cart attributes (__nuit_clk) on Add-to-Cart, /cart load,
 *      and dynamic-checkout / Buy-it-Now clicks (belt-and-suspenders, see §3.2 GOTCHA).
 *
 * Config via window.NUIT_TRACK (set BEFORE loading this script), all optional:
 *   { endpoint, cookieDomain, cookieDays }
 */
(() => {
  var CFG = window.NUIT_TRACK || {};
  var DOMAIN = CFG.cookieDomain || '.nuit.ro';
  var COOKIE = '__nuit_clk';
  var DAYS = CFG.cookieDays || 90;
  // The legacy collector is retired. The Coolify Shopify pixel has a separate API.
  var EP = CFG.endpoint || '';

  function getCookie(n) {
    var m = document.cookie.match('(^|;)\\s*' + n + '\\s*=\\s*([^;]+)');
    return m ? decodeURIComponent(m.pop()) : '';
  }
  function setCookie(n, v, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 864e5);
    document.cookie =
      n +
      '=' +
      encodeURIComponent(v) +
      ';expires=' +
      d.toUTCString() +
      ';path=/;domain=' +
      DOMAIN +
      ';SameSite=Lax;Secure';
  }
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      var r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  var qs = new URLSearchParams(location.search);
  function p(k) {
    return qs.get(k) || '';
  }

  // Platform click-ids - never fabricate, only persist what is really present.
  var fbclid = p('fbclid'),
    gclid = p('gclid'),
    gbraid = p('gbraid'),
    wbraid = p('wbraid'),
    ttclid = p('ttclid'),
    rtkcid = p('rtkcid');
  var hasPaid = !!(fbclid || gclid || gbraid || wbraid || ttclid || rtkcid);

  var prev = {};
  try {
    prev = JSON.parse(getCookie(COOKIE) || '{}');
  } catch (e) {}

  var rec;
  // LAST-PAID: overwrite only when a NEW paid click-id arrives; otherwise keep existing cookie.
  if (hasPaid || !prev.ourClickId) {
    rec = {
      ourClickId: prev.ourClickId || uuid(),
      anonymousId: prev.anonymousId || uuid(),
      fbclid: fbclid || (hasPaid ? '' : prev.fbclid) || '',
      gclid: gclid || (hasPaid ? '' : prev.gclid) || '',
      gbraid: gbraid || prev.gbraid || '',
      wbraid: wbraid || prev.wbraid || '',
      ttclid: ttclid || (hasPaid ? '' : prev.ttclid) || '',
      rtkcid: rtkcid || prev.rtkcid || '',
      // fbc format: fb.1.{ms}.{fbclid}; fbp read from _fbp cookie.
      fbc: fbclid ? 'fb.1.' + Date.now() + '.' + fbclid : prev.fbc || '',
      fbp: getCookie('_fbp') || prev.fbp || '',
      ttp: getCookie('_ttp') || prev.ttp || '',
      cmpid: p('cmpid') || prev.cmpid || '',
      adId: p('ad_id') || p('sub1') || prev.adId || '',
      adsetId: p('adset_id') || p('sub2') || prev.adsetId || '',
      utm_source: p('utm_source') || prev.utm_source || '',
      utm_medium: p('utm_medium') || prev.utm_medium || '',
      utm_campaign: p('utm_campaign') || prev.utm_campaign || '',
      utm_term: p('utm_term') || prev.utm_term || '',
      utm_content: p('utm_content') || prev.utm_content || '',
      lp: location.pathname,
      ref: document.referrer || '',
      ts: Date.now(),
      paid: hasPaid || !!prev.paid,
    };
    setCookie(COOKIE, JSON.stringify(rec), DAYS);

    // Server-side safety net (independent of cart-attr). keepalive => survives navigation.
    try {
      if (EP) fetch(EP, {
        method: 'POST',
        keepalive: true,
        mode: 'cors',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(rec),
      }).catch(() => {});
    } catch (e) {}
  } else {
    rec = prev;
  }
  window.__nuitClk = rec;

  // ---- Cart attribute write (puente click -> order via note_attributes) ----
  function writeAttr() {
    var clk = window.__nuitClk;
    if (!clk || !clk.ourClickId) return;
    // Never create a competing empty cart before the first add finishes.
    // A late cart/update response would replace the new populated cart cookie.
    if (!getCookie('cart')) return;
    var routes = (window.theme && window.theme.routes) || {};
    var url = routes.cart_update_url || '/cart/update.js';
    var body = JSON.stringify({
      // '__' prefix => Shopify marks it PRIVATE (hidden in checkout UI, present on order webhook).
      attributes: { __nuit_clk: JSON.stringify(clk) },
    });
    var cfg =
      window.theme && window.theme.utils && window.theme.utils.fetchConfig
        ? window.theme.utils.fetchConfig()
        : { headers: { 'Content-Type': 'application/json' } };
    fetch(url, Object.assign({}, cfg, { method: 'POST', body: body })).catch(() => {});
  }

  // 1) On /cart load (a fresh cart starts empty -> (re)write).
  if (location.pathname.indexOf('/cart') === 0) writeAttr();

  // AJAX add success can arrive after the submit timer; reuse its existing cart.
  var observingCart = false;
  function observeCart() {
    var bus = window.theme && window.theme.pubsub;
    if (observingCart || !bus || !bus.PUB_SUB_EVENTS) return;
    observingCart = true;
    bus.subscribe(bus.PUB_SUB_EVENTS.cartUpdate, writeAttr);
  }
  observeCart();
  document.addEventListener('DOMContentLoaded', observeCart, { once: true });

  // 2) On Add-to-Cart (intercept form submit to /cart/add).
  document.addEventListener(
    'submit',
    (e) => {
      var f = e.target;
      if (f && f.action && f.action.indexOf('/cart/add') !== -1) setTimeout(writeAttr, 600);
    },
    true,
  );

  // 3) Buy-it-Now / dynamic checkout: write eagerly on any checkout-button click.
  document.addEventListener(
    'click',
    (e) => {
      var t =
        e.target.closest &&
        e.target.closest('[name="add"], .shopify-payment-button__button, [href="/checkout"]');
      if (t) writeAttr();
    },
    true,
  );
})();
